var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manual-content card-item" }, [
    _c("h3", { staticClass: "text-align-center" }, [
      _vm._v("Realiza tu transferencia"),
    ]),
    _c("div", { staticClass: "transfer-process" }, [
      _c("div", { staticClass: "transfer-card card-animation-content" }, [
        _c("div", { staticClass: "card-item front-card" }, [
          _vm._m(0),
          _vm._m(1),
          _vm._m(2),
          _c("p", { staticClass: "has-text-centered" }, [
            _c(
              "button",
              {
                staticClass: "button is-button-primary is-rounded",
                class: { "is-hidden": _vm.isClicked },
                attrs: { id: "button-view-bank-account" },
                on: {
                  click: function ($event) {
                    _vm.isClicked = true
                  },
                },
              },
              [_vm._v(" Ver datos ")]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "transfer-card card-animation-content" }, [
        _c(
          "div",
          {
            staticClass: "card-item front-card",
            class: { "rotate-left-leave-to": _vm.isClicked },
            attrs: { id: "transfer-image" },
          },
          [
            _c("h4", { staticClass: "has-text-centered" }, [
              _vm._v("Transfiere"),
            ]),
            _vm._m(3),
          ]
        ),
        _vm._m(4),
        _c(
          "div",
          {
            staticClass: "card-item back-card",
            class: {
              "rotate-left-enter-to": _vm.isClicked,
              show: _vm.isClicked,
            },
            attrs: { id: "data-card" },
          },
          [
            _vm._m(5),
            _c("p", [_vm._v("Datos de la cuenta destino:")]),
            _c("ul", { staticClass: "account-data" }, [
              _c("li", [
                _vm._m(6),
                _c(
                  "a",
                  {
                    staticClass: "is-pulled-right",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.copy($event)
                      },
                    },
                  },
                  [_c("i", { staticClass: "far fa-copy fa-lg" })]
                ),
                _c("div", { staticClass: "is-clearfix" }),
              ]),
              _c("li", [
                _vm._m(7),
                _c(
                  "a",
                  {
                    staticClass: "is-pulled-right",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.copy($event)
                      },
                    },
                  },
                  [_c("i", { staticClass: "far fa-copy fa-lg" })]
                ),
                _c("div", { staticClass: "is-clearfix" }),
              ]),
              _vm._m(8),
              _vm._m(9),
              _c("li", [
                _vm._m(10),
                _c(
                  "a",
                  {
                    staticClass: "is-pulled-right",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.copy($event)
                      },
                    },
                  },
                  [_c("i", { staticClass: "far fa-copy fa-lg" })]
                ),
                _c("div", { staticClass: "is-clearfix" }),
              ]),
              _c("li", [
                _vm._m(11),
                _c(
                  "a",
                  {
                    staticClass: "is-pulled-right",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.copy($event)
                      },
                    },
                  },
                  [_c("i", { staticClass: "far fa-copy fa-lg" })]
                ),
                _c("div", { staticClass: "is-clearfix" }),
              ]),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "transfer-card card-animation-content" }, [
        _c(
          "div",
          {
            staticClass: "card-item front-card",
            class: { "rotate-left-leave-to": _vm.isClicked },
          },
          [
            _c("h4", { staticClass: "has-text-centered" }, [
              _vm._v("Confirma"),
            ]),
            _vm._m(12),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "card-item back-card",
            class: {
              "rotate-left-enter-to": _vm.isClicked,
              show: _vm.isClicked,
            },
          },
          [
            _vm._m(13),
            _c("div", { staticClass: "confirm-card-content" }, [
              _c("div", [
                _vm._v(" ¿Vas a transferir desde la cuenta de un conocido? "),
                _c(
                  "button",
                  {
                    staticClass:
                      "button is-button-secondary is-rounded is-small",
                    attrs: {
                      id: "button-add-trusted-id-number",
                      href: "#anchor-mobile-transfer",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open-trusted-ids-modal", true)
                      },
                    },
                  },
                  [_vm._v(" Agregar persona de confianza ")]
                ),
              ]),
              _c("div", [
                _vm._m(14),
                _c("div", { staticClass: "buttons is-centered" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-button-primary is-rounded is-small",
                      attrs: { id: "button-already-transferred" },
                      on: { click: _vm.triggerModal },
                    },
                    [_vm._v(" Sí, ya la hice ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-button-secondary is-rounded is-small",
                      attrs: {
                        id: "button-didnt-transfer",
                        href: "#anchor-mobile-transfer",
                      },
                      on: { click: _vm.shakeSenora },
                    },
                    [_vm._v(" No, aún no ")]
                  ),
                ]),
              ]),
              _c("div", [
                _vm._m(15),
                _c(
                  "p",
                  {
                    staticClass: "has-text-centered",
                    staticStyle: { color: "red" },
                  },
                  [_vm._v(_vm._s(_vm.errorMessage))]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-card" }, [
      _c("h4", { staticClass: "is-pulled-left" }, [_vm._v("Inicia")]),
      _c("div", { staticClass: "icon-front is-pulled-right" }, [
        _c("img", {
          attrs: { src: require("@/ui/assets/img/instrucciones.svg") },
        }),
      ]),
      _c("div", { staticClass: "is-clearfix" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("¿Cómo "),
      _c("b", [_vm._v("transferir")]),
      _vm._v(" desde tu banco?"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", { staticClass: "transfer-steps" }, [
      _c("li", [_vm._v("Ingresa a la app o página web de tu banco")]),
      _c("li", [
        _vm._v("Agrega un nuevo destinatario con los datos de Creditú"),
      ]),
      _c("li", [_vm._v("Transfiere el total, desde una cuenta con tu Rut")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-back" }, [
      _c("img", { attrs: { src: require("@/ui/assets/img/transfiere.svg") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "anchor" }, [
      _c("div", { attrs: { id: "anchor-mobile-transfer" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-card" }, [
      _c("h4", { staticClass: "is-pulled-left" }, [_vm._v("Transfiere")]),
      _c("div", { staticClass: "icon-front is-pulled-right" }, [
        _c("img", {
          attrs: { src: require("@/ui/assets/img/transfiere.svg") },
        }),
      ]),
      _c("div", { staticClass: "is-clearfix" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-pulled-left" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Titular")]),
      _vm._v("Creditu S.A."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-pulled-left" }, [
      _c("span", { staticClass: "label" }, [_vm._v("RUT")]),
      _vm._v("76.594.721-9"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("span", { staticClass: "label" }, [_vm._v("Banco")]),
      _vm._v("Banco de Crédito e Inversiones (BCI)"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("span", { staticClass: "label" }, [_vm._v("Tipo de cuenta")]),
      _vm._v("Cuenta Corriente"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-pulled-left" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Número de cuenta")]),
      _vm._v("35428546"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-pulled-left" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Correo electrónico")]),
      _vm._v("pagos@creditu.com "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-back" }, [
      _c("img", { attrs: { src: require("@/ui/assets/img/confirma.svg") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-card" }, [
      _c("h4", { staticClass: "is-pulled-left" }, [_vm._v("Confirma")]),
      _c("div", { staticClass: "icon-front is-pulled-right" }, [
        _c("img", { attrs: { src: require("@/ui/assets/img/confirma.svg") } }),
      ]),
      _c("div", { staticClass: "is-clearfix" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "has-text-centered" }, [
      _vm._v("¿Ya realizaste la "),
      _c("b", [_vm._v("transferencia")]),
      _vm._v("?"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "has-text-centered" }, [
      _vm._v(" Recuerda enviar tu(s) comprobante(s) a "),
      _c("b", [_vm._v("pagos@creditu.com")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }